<template>
  <div class="chat-loading" >
    <CommonImage class="loading-animation" :imageStyle="`width: ${size}px; height: ${size}px`" src="/assets/chat/icon_ai_loading.png" />
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";

let call = defineEmits(["onChooseLang", "onLockLang"])

interface Props {
  size: number,  // 加载loding
}
const props = defineProps<Props>()

onMounted(()=>{
 
})

</script>

<style lang="less">
.chat-loading {
  display: flex;
  .loading-animation {
    animation: spin 0.5s linear infinite;
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


</style>
